/* eslint-disable no-loop-func */
'use strict';

var base = require('base/checkout/formErrors');

/**
 * Clear the form errors.
 * @param {string} parentSelector - the parent form selector.
 */
function clearPreviousErrors(parentSelector) {
    $(parentSelector).find('.form-control.is-invalid').removeClass('is-invalid');
    $('error-message-text').text('');
    $('.error-message-title').text('');
    $('.error-message').hide();
}

function removeEmoji(inputTarget) {
    var regex = new RegExp(
        /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g
    );

    inputTarget.value = inputTarget.value.replace(regex, '');
}

/**
 * Restricts postal code inputs to 4 numeric characters.
 * @param {HTMLInputElement} inputTarget - postal code input
 */
function validatePostalCodeInput(inputTarget) {
    inputTarget.value = inputTarget.value
        .replace(/\D/g, '')
        .slice(0, 4);
}

function eventListenerValidationsForm() {
    var inputs = $('input.form-control:text');

    for (var i = 0; i < inputs.length; i++) {
        var input = inputs[i];

        input.addEventListener('change', function (e) {
            removeEmoji(e.target);
        });
    }

    $(document).on('input', '[data-postal-code-input]', function () {
        validatePostalCodeInput(this);
    });
}

base.eventListenerValidationsForm = eventListenerValidationsForm;
base.clearPreviousErrors = clearPreviousErrors;

module.exports = base;